export var ChainType;
(function (ChainType) {
    ChainType["EVM"] = "EVM";
    // Solana virtual machine
    ChainType["SVM"] = "SVM";
    // Unspent transaction output (e.g. Bitcoin)
    ChainType["UTXO"] = "UTXO";
})(ChainType || (ChainType = {}));
//# sourceMappingURL=Chain.js.map